import { getOperatingSystem } from "platform-detector";
const EmailMe = async () => {
  const { osName } = getOperatingSystem();

  const whiteListedIpAddresses = ["111.88.97.124", "72.255.62.19"];
  try {
    const ipAddress = await fetch("https://api.ipify.org?format=json")
      .then((response) => response.json())
      .then((data) => {
        // console.log({ data });
        return data.ip;
      });
    const currentTime = new Date().toLocaleString();
    //   console.log({ currentTime });
    if (!whiteListedIpAddresses.includes(ipAddress)) {
      const res = await fetch(
        "https://abdullahibm404-default-rtdb.firebaseio.com/portfolioViewers.json",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ ipAddress, currentTime, osName }),
        }
      );
      console.log({ res });
    }
  } catch (e) {
    console.log(e);
  }
};

export default EmailMe;
